<i18n>
  {
    "fr": {
      "increasing-price-order": "Prix: croissant",
      "decreasing-price-order": "Prix: décroissant",
      "no-itineraries-found": "Aucun vol trouvé. Essayez de relancer la recherche avec d'autre paramètres.",
      "unselect": "Désélectionner"
    },
    "en": {
      "increasing-price-order": "Price: increasing",
      "decreasing-price-order": "Price: decreasing",
      "no-itineraries-found": "No flights found. Try to restart the search with different parameters",
      "unselect": "Unselect"
    }
  }
</i18n>

<template>
  <div v-scroll="onScroll">
    <FlightSearchResultsScrollButton
      :offset-top="offsetTop"
    />
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <transition name="clear-selection-button">
          <v-btn
            v-show="selectedItinerary > -1 && !intersectingIndexes.includes(selectedItinerary)"
            id="clear-selection-button"
            color="primary"
            v-bind="attrs"
            fab
            v-on="on"
            @click="triggerUnSelect = !triggerUnSelect; selectedItinerary = undefined"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </transition>
      </template>
      <span>{{ $t('unselect') }}</span>
    </v-tooltip>
    <div>
      <FlightSearchResultsGroupPrice
        v-for="(itinerary, index) in itineraries"
        :key="index"
        class="mb-1"
        :group-price="itinerary.itinerary"
        :the-price="itinerary.price"
        :is-disabled="itineraryDisabled(index)"
        :trigger-un-select="triggerUnSelect"
        @is-intersecting="itineraryIsIntersecting($event, index)"
        @has-selection="itineraryHasSelection($event, index)"
      />
    </div>
    <v-card
      v-if="unfilteredItinerariesList.length === 0 && !isLoading"
      class="mx-auto my-1"
      height="400px"
      flat
    >
      <div
        id="no-itineraries-found-text"
      >
        <v-img
          class="mx-auto"
          width="190px"
          src="@/assets/img/paper-plane.svg"
        />
        <p
          class="mb-0 mx-auto my-12 text-center"
        >
          {{ $t('no-itineraries-found') }}
        </p>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FlightSearchResultsGroupPrice from './FlightSearchResultsGroupPrice/FlightSearchResultsGroupPrice/FlightSearchResultsGroupPrice'
import FlightSearchResultsScrollButton from './FlightSearchResultsScrollButton/FlightSearchResultsScrollButton'

export default {
  name: 'FlightSearchResults',
  components: {
    FlightSearchResultsScrollButton,
    FlightSearchResultsGroupPrice
  },
  data: () => ({
    selectedItinerary: undefined,
    offsetTop: 0,
    triggerUnSelect: false,
    intersectingIndexes: []
  }),
  computed: {
    ...mapState({
      unfilteredItinerariesList: state => state.fb.searchResults.itineraries,
      priceSortOrder: state => state.fb.searchFilters.priceSortOrder,
      isLoading: state => state.fb.step2Loading
    }),
    ...mapGetters({
      itineraries: 'fb/searchResults/filteredItineraries'
    })
  },
  methods: {
    ...mapActions({
      changePriceSortOrder: 'fb/searchFilters/switchPriceSortOrder'
    }),
    /**
     * Return true if the index is the same as the selectedItinerary
     * @param index {number}
     * @return {boolean}
     */
    itineraryDisabled (index) {
      if (this.selectedItinerary === undefined) {
        return false
      } else if (this.selectedItinerary === index) {
        return false
      } else return this.selectedItinerary !== index
    },
    /**
     * Set a new value to selectedItinerary based on event bool
     * @param eventBool
     * @param index {number}
     */
    itineraryHasSelection (eventBool, index) {
      if (eventBool) {
        this.selectedItinerary = index
      } else {
        this.selectedItinerary = undefined
      }
    },
    itineraryIsIntersecting (eventBool, index) {
      if (eventBool) {
        this.intersectingIndexes.push(index)
      } else {
        const findIndex = this.intersectingIndexes.findIndex((e) => e === index)
        if (findIndex > -1) {
          this.intersectingIndexes = this.intersectingIndexes.filter((e) => e !== index)
        }
      }
    },
    /**
     * Assign a new value to offsetTop based on window.scrollY
     */
    onScroll () {
      this.offsetTop = window.scrollY
    }
  }
}
</script>

<style scoped>
  #no-itineraries-found-text{
    position: relative;
    top: 69px;
  }

  .v-skeleton-loader >>> .v-skeleton-loader__button {
    margin: auto;
    width: 140px;
  }

  .v-skeleton-loader.price >>> .v-skeleton-loader__heading {
    margin: auto;
    width: 140px;
  }

  #clear-selection-button {
    position: fixed;
    left: 3rem;
    bottom: 3rem;
    z-index: 1;
  }

  .clear-selection-button-enter-active {
    animation: clear-selection-button 0.4s;
  }
  .clear-selection-button-leave-active {
    transition: opacity 0.4s
  }
  .clear-selection-button-enter, .clear-selection-button-leave-to {
    opacity: 0;
  }

  @keyframes clear-selection-button {
    from {
      transform: rotate(-90deg) scale(0);
    }
    to {
      transform: rotate(0deg) scale(1);
    }
  }

</style>
